import { Maybe } from "@flockcover/flock-svc-core-types"
import { Analytics } from "../types"
import { TripVehicle } from "./types"

export type MockTripVehicle = Omit<Partial<TripVehicle>, "currentPeriod" | "previousPeriod" | "total"> & {
  currentPeriod: Partial<Analytics>
  previousPeriodScore: Maybe<number>
}

export const generateTripVehicle = (mock?: MockTripVehicle): TripVehicle => ({
  vrn: `ABC 123`,
  name: `Mercedes-Benz Class A`,
  vehicleType: `car`,
  totalDistance: null,
  totalSafetyScore: null,
  ...mock,
  currentPeriod: {
    score: 90,
    averageSpeedExceedencePercentage: null,
    distance: 0,
    distanceSpentSpeeding: null,
    speedBands: null,
    ...mock?.currentPeriod,
  },
  previousPeriodScore: mock?.previousPeriodScore ?? 80,
})

export const generateTripVehicles = (mocks: Array<MockTripVehicle>): ReadonlyArray<TripVehicle> =>
  mocks.map((it) => generateTripVehicle(it))
